import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@mui/material';
import MKButton from 'components/MKButton';
import { DeleteOutline } from '@mui/icons-material';
import RestClient from 'services/RestClient';
import { showToastMessage } from "../../helpers/toastHelper";
import MKInput from 'components/MKInput';

function DeleteDealerModal({ dealerID }) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);

    const handleClickOpen = () => {
        setInputValue("");
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDeleteDealer = async () => {
        setIsDeleting(true);
        const result = await RestClient.delete(`/api/dealers`, { ids: [dealerID] });
        if (result?.status === 200) {
            showToastMessage("Dealer has been successfully deleted", "success");
            navigate("/dealers");
        } else {
            showToastMessage(result?.message, "error");
        }
        setIsDeleting(false);

        handleClose();
    };

    useEffect(() => {
        setIsDisabled(true);
        if (inputValue === 'Delete') {
            setIsDisabled(false);
        }
    }, [inputValue]);

    return (
        <>
            <MKButton variant="outlined" color="error" endIcon={<DeleteOutline />} onClick={handleClickOpen} >
                Delete Dealer
            </MKButton>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Delete Dealer</DialogTitle>
                <DialogContent
                    style={{ marginBottom: '0' }}
                >
                    <p>Are you sure you want to delete this dealer?</p>
                    <p>Please type "Delete" to proceed:</p>
                    <MKInput
                        variant="standard"
                        required
                        label=""
                        sx={{ marginTop: 1 }}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        inputProps={{ maxLength: 6 }}
                    />
                </DialogContent>
                <DialogActions>
                    <MKButton onClick={handleClose}>Cancel</MKButton>
                    <MKButton endIcon={isDeleting ? <CircularProgress color="inherit" size={20} /> : <DeleteOutline />} color="error" disabled={isDeleting || isDisabled} onClick={handleDeleteDealer}>
                        {isDeleting ? "Deleting..." : "Delete"}
                    </MKButton>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default DeleteDealerModal;